import { IBraze } from '@grubhubprod/umami-library/dist/braze/types';
import { Platform } from 'src/environment';
import { asyncLoadLibrary } from 'src/shared/utilities/asyncLoadLibrary';
import { windowFactory } from 'src/shared/factories';
import type { CredentialService } from 'src/shared/services';
import { CredentialServiceImpl } from 'src/shared/services/credential-service';

export const loadBraze = async (libraryURL: string): Promise<unknown> => {
  const windowInstance = windowFactory();
  const { platform } = windowInstance.ghsConfiguration;
  let rv = Promise.resolve();
  if (platform === Platform.WEB) {
    rv = asyncLoadLibrary({
      id: 'braze-script',
      url: libraryURL,
      isAppend: false,
      attributes: { async: '' },
      onLoad: () => initializeBraze(windowInstance),
    });
  }
  return rv;
};

function initializeBraze(windowInstance: Window) {
  const credentialsService: CredentialService =
    CredentialServiceImpl.getInstance();
  const { brazeOptions, brazeId } = windowInstance.ghsConfiguration;
  const braze: IBraze = windowInstance.braze;

  braze.initialize(brazeId, brazeOptions);
  braze.openSession();

  const account = credentialsService.getCredentialUdid();
  if (account) {
    braze.changeUser(account);
  }
}
